import PageRenderer from '../../components/PageRenderer/PageRenderer';

function AITools() {
  return <PageRenderer pageKey="aiTools" />;
}

export default AITools;
